module.exports = __webpack_public_path__ + "static/media/OVERTEMP_OFF.f623a63c.png";